import React from 'react';
import classNames from 'classnames';

const Featured = ({ size, title = "We've been featured in&hellip;", background, showAdsWeek }) => (
  <section className={classNames('block block-featured', size, background)}>
    <div className="row columns text-center">
      <h3 dangerouslySetInnerHTML={{ __html: title }} />
    </div>
    <div className="row">
      <div className="small-10 small-offset-3 medium-6 medium-offset-2 medium-order-1 large-4 columns">
        <img
          alt="Wall Street Journal logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_wsj.png"
          className="featured-image"
        />
      </div>
      <div className="small-10 small-offset-3 medium-6 medium-offset-2 medium-order-5 large-4 large-offset-0 columns">
        <img
          alt="Forbes logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_forbes.png"
          className="featured-image"
        />
      </div>
      <div className="small-10 small-offset-3 medium-6 medium-order-2 medium-offset-0 large-4 columns">
        <img
          alt="Bloomberg Business logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_bloomberg.png"
          className="featured-image"
        />
      </div>
      <div className="small-10 small-offset-3 medium-6 medium-offset-2 medium-order-3 large-4 large-offset-0 columns">
        <img
          alt="New York Times logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_nyt.png"
          className="featured-image" />
      </div>
      <div className="small-10 small-offset-3 medium-6 medium-order-6 medium-offset-0 large-4 columns text-center">
        { showAdsWeek?
        <img
          alt="Advertisingweek logo"
          src="https://assets.crowdspring.com/marketing/cs-marketing-advertisingweek-logo.png"
          className="featured-image"
        /> :
        <img
          alt="Fast Company logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_fast-company.png"
          className="featured-image"
        /> }
      </div>
      <div className="small-10 small-offset-3 medium-6 medium-order-4 medium-offset-0 large-4 large-offset-2 columns">
        <img
          alt="Entrepreneur Magazine logo"
          src="https://assets.crowdspring.com/marketing/crowdspring_marketing_featured_entrepreneur.png"
          className="featured-image"
        />
      </div>
    </div>
  </section>
);

export default Featured;
